import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../stateStore';
import { GlobalStateSlice } from '../../types/globalTypes';

export const initialGlobalState: GlobalStateSlice = {
  currentError: {},
  selectedWorkspace: undefined,
  showErrorModal: false,
  showErrorPage: false,
};

const globalStateSlice = createSlice({
  initialState: initialGlobalState,
  name: 'globalState',
  reducers: {
    scrollToTop: (state) => {
      state.scrollToTop = new Date().toISOString();
    },
    setCurrentError: (state, action) => {
      state.currentError = action.payload;
    },
    setSelectedWorkspace: (state, action) => {
      state.selectedWorkspace = action.payload;
    },
    setShowErrorModal: (state, action) => {
      state.showErrorModal = action.payload;
    },
    setShowErrorPage: (state, action) => {
      state.showErrorPage = action.payload;
    },
  },
});

const globalSelectors = {
  currentError: (state: RootState) => state.globalReducer.currentError,
  scrollToTop: (state: RootState) => state.globalReducer.scrollToTop,
  selectedWorkspace: (state: RootState) =>
    state.globalReducer.selectedWorkspace,
  showErrorModal: (state: RootState) => state.globalReducer.showErrorModal,
  showErrorPage: (state: RootState) => state.globalReducer.showErrorPage,
};

export const globalService = {
  actions: globalStateSlice.actions,
  cognitoSignOut: undefined as (() => Promise<void>) | undefined,
  getAccessTokenSilently: () => Promise.resolve(''),
  selectors: globalSelectors,
};

export default globalStateSlice.reducer;
